module.exports = __webpack_public_path__ + "static/media/blck8.b427b9ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/black/blck8.jpg
// module id = 472
// module chunks = 0